function decorateTab(tab, panel) {
  tab.setAttribute("role", "tab");
  if (panel) {
    panel.setAttribute("role", "tabpanel");
    panel.tabIndex = 0;
  }
}
function connectTabWithPanel(tab, panel, baseId, index) {
  tab.setAttribute("id", `${baseId}-tab-${index}`);
  tab.setAttribute("aria-controls", `${baseId}-tabpanel-${index}`);
  panel.setAttribute("aria-labelledby", `${baseId}-tab-${index}`);
  panel.setAttribute("id", `${baseId}-tabpanel-${index}`);
}
function updateSelectedState(tab, panel, selected = false) {
  tab.tabIndex = selected ? 0 : -1;
  tab.setAttribute("aria-selected", selected.toString());
  if (panel) {
    panel.hidden = !selected;
    panel.classList.toggle("skapa-active-panel", selected);
  }
}
export {
  connectTabWithPanel,
  decorateTab,
  updateSelectedState
};
